<template>

  <v-container>

    <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        class="elevation-1"
      >
      <template  v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.d.name_fr }}</td>
                  <td>{{ item.d.city }}</td>
                  <td> <v-btn icon @click.prevent="show(item)"><v-icon>mdi-magnify</v-icon></v-btn>
                    <v-btn @click.prevent="edit(item)" icon><v-icon>mdi-pencil</v-icon></v-btn>
                    <v-btn icon @click.prevent="del(item)"><v-icon>mdi-delete</v-icon></v-btn></td>
                </tr>
              </tbody>
            </template>

    </v-data-table>
  </v-container>
</template>
<script>
import firebase from '@firebase/app';
import   '@firebase/firestore';
export default {
  props: ['entity' ,'headers', 'show', 'edit', 'search'],
  data: () => ({
    items: [],
    page: 0,
    options: {itemsPerPage: 30},
    previous: {first: null, last: null},
    total: 2000,
    nextId: 0,
    itemsPerPage: 30,
    pageCount:0,
    lastItem: null,
    loading: false,
    cpt: 0,
  }),
  watch: {
    search() {
      //console.log(this.search);
      //this.options.page += 1;
      //this.options.page -= 1;
      this.options.sortBy = [];

    },
    options: {
      handler(x, o) {
        if (x.page < o.page) {
          this.loadPreviousItems(x.page - 1);

        } else {
          this.loadNextItems(x.page - 1);
        }

      },
        deep: true
    }
  },
  methods: {
    del(item) {
      const firestore = firebase.firestore();

      if (window.confirm('Etes-vous sûr de vouloir supprimer cet élément ?')){
          firestore.collection(this.entity).doc(item.ref).delete().then(() => {

          }).catch(() => {

          });
      }
    },
    loadNextItems() {
      const firestore = firebase.firestore();
        this.loading = true;
        let query = null;
        if (Object.keys(this.search).length > 0) {
          let s = this.search[0];
          let a = [];
          a.push(s.term[0].toUpperCase() + s.term.slice(1));
          a.push(s.term.toLowerCase());
          a.push(s.term);
          a.push(s.term.toUpperCase());
          if (this.search[0].field.type == 'in') {

            query = firestore.collection(this.entity).where('d.'+s.field.value, 'in', a).startAfter(this.nextId).limit(this.itemsPerPage);
          } else {
            if(s.field.value== 'name_fr'){
              s.field.value = 'keywords_name';
            }
            query = firestore.collection(this.entity).where('d.keywords_name', 'array-contains-any', a).limit(this.itemsPerPage);

            //query = firestore.collection(this.entity).where('d.'+s.field.value, 'array-contains-any', a).startAfter(this.nextId).limit(this.itemsPerPage);

          }


        } else {
          if (this.nextId == undefined) {
            this.nextId = 0;
          }
          query = firestore.collection(this.entity).orderBy('d.name_fr').startAfter(this.nextId).limit(this.itemsPerPage);
        }
        query.onSnapshot((s)=> {

        //
      //firestore.collection(this.entity).orderBy('d.name_fr').startAfter(this.nextId).limit(this.itemsPerPage).get().then((s)=> {
        this.items = s.docs.map(d => { return {...{ref:d.id }, ...d.data()} });
        this.nextId =  s.docs[s.docs.length -1 ];
        this.firstId = s.docs[0];
          this.loading = false;
      });

    },
    loadPreviousItems() {
      const firestore = firebase.firestore();
        this.loading = true;
      firestore.collection(this.entity).orderBy('d.name_fr').endBefore(this.firstId).limitToLast(this.itemsPerPage).get().then((s)=> {
        this.items = s.docs.map(d => { return {...{ref:d.id }, ...d.data()} });

        this.nextId =  s.docs[s.docs.length -1 ];
        this.firstId = s.docs[0];

          this.loading = false;
      });
    }
  }
}

</script>
